<template>
    <div class="Man-CorretivaPrincipal">
        <PageTitle icon="fa fa-gear" main="Corretivas"
            sub="Manutenção Corretiva" />
        <div class="Man-CorretivaPrincipal">
            <b-card no-body>
                <b-tabs>                                        
                    <b-tab title="Corretiva" active><CorretivaLancamento /></b-tab>                                                                                                                        
                 <!--   <b-tab title="Gráfico" ><CorretivaGrafico /></b-tab>                                                                                                                        -->
                    <b-tab title="Grupo" ><CorretivaGrupo /></b-tab>                                                                                                                        
                    <b-tab title="SubGrupo" ><CorretivaSubGrupo /></b-tab>                                                                                                                        
                    <b-tab title="Defeitos" ><CorretivaDefeitos /></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import CorretivaLancamento from '../man_corretiva/CorretivaLancamento'
import CorretivaGrafico from '../man_corretiva/CorretivaGrafico'
import CorretivaGrupo from '../man_corretiva/CorretivaGrupo'
import CorretivaSubGrupo from '../man_corretiva/CorretivaSubGrupo'
import CorretivaDefeitos from '../man_corretiva/CorretivaDefeitos'

export default {
    name: 'LinhaPrincipal',    
    components: { PageTitle, CorretivaLancamento, CorretivaGrafico,CorretivaGrupo,CorretivaSubGrupo,CorretivaDefeitos}
    
}
</script>

<style>

</style>






